const pages = {
  index: '/welcome',
  editAddress: '/welcome/edit-address',
  genericOnboarding: '/onboarding/:id',
};

export default pages;
